<div class="d-flex flex-column bg-white rounded-2 gap-4" style="padding-top: 20px;">
  <div class="d-flex flex-column gap-4 voucher-search-filter">
    <div class="d-flex justify-content-between align-items-center modal-header p-0">
      <div class="voucher-header-title" style="font-size: 24px; font-weight: 600;">Danh sách Voucher</div>
      <button *ngIf="isCheckout" class="btn btn-close btn-sm" [id]="'voucher_modal_close_btn'" style="position: unset !important;"
        (click)="closeModal()">
        <i class="ri-close-line"></i>
      </button>
    </div>
    <div class="d-flex flex-column" style="gap: 10px;">
      <form [formGroup]="form" (ngSubmit)="inputKeyword()">
        <div class="search-container">
          <input
            #voucherSearchInput
            id="voucherSearchInput"
            type="search"
            class="search-input w-100"
            placeholder="Bạn đang tìm voucher nào?"
            formControlName="searchInput"
            (keyup)="inputKeyword()"
            (search)="inputKeyword()"
          />
          <button
            type="submit"
            class="search-button"
            id="voucherSearchBtn"
          >
            <img src="assets/svg/voucher/search.svg" style="width: 20px; height: 20px;"  loading="lazy" />
          </button>
        </div>
      </form>

      <div class="d-flex align-items-center w-100 overflow-auto" style="gap: 12px;">
        <button *ngFor="let tag of voucherTags" class="filter-btn bg-white mb-1"
          [class]="tag.active ? 'active' : ''" (click)="selectTag(tag)">
          <span class="w-max-content">{{ tag.name }}</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="voucherGroups.length && !skeletonLoader; else skeletonLoaderTemplate" class="voucher-list" [class.modal-list]="isCheckout">
    <div *ngFor="let group of voucherGroups" class="voucher-group">
      <ng-container *ngIf="group.vouchers.length > 0">
        <div class="p-2" style="background-color: #F3F3F3;">
          <span class="group-name">{{group.collection.name}}</span>
        </div>
        <div class="voucher-container">
          <ng-container *ngFor="let voucher of group.vouchers; let i = index">
            <app-voucher-item *ngIf="i < 6 || group.isExpanded || !isCheckout" [voucher]="voucher" [isCheckout]="isCheckout" class="d-flex w-100" (applyVoucher)="applyVoucher.emit($event)"></app-voucher-item>
          </ng-container>
        </div>
        <div *ngIf="group.vouchers.length > 6 && isCheckout" class="expand" (click)="group.isExpanded = !group.isExpanded">
          <span style="font-size: 14px; font-weight: 600; color: var(--theme-color);">{{ group.isExpanded ? 'Ẩn bớt' : 'Xem thêm' }}</span>
          <img src="assets/svg/voucher/chevron-down.svg" class="expand-icon" [class.expanded]="group.isExpanded"  loading="lazy" />
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #skeletonLoaderTemplate>
    <ng-container *ngIf="skeletonLoader else noVouchers">
      <div class="row px-4">
        <div *ngFor="let item of skeletonItems" class="col-6">
          <app-skeleton-product-box class="w-50" [style]="'vertical'"></app-skeleton-product-box>
        </div>
      </div>
    </ng-container>
  </ng-template>
  
  <ng-template #noVouchers>
    <div class="d-flex flex-column align-items-center" style="padding: 40px 0; gap: 20px;">
      <img src="assets/svg/voucher/no-data.svg" style="width: 200px; height: 200px;" loading="lazy" />
      <span class="no-voucher-title">Hiện tại bạn chưa có voucher nào cả</span>
    </div>
  </ng-template>
</div>
